import layout from '@/views/common/layout'
const yd = [
    {
        path: '/yd',
        component: layout,
        children: [
            {
                path: 'goodsList',
                component: () => import('@/views/yd/sys/goodsList'),
                name: 'goodsList',
                meta: { title: '商品管理', icon: '', affix: true }
            },
            {
                path: 'brandList',
                component: () => import('@/views/yd/sys/brandList'),
                name: 'brandList',
                meta: { title: '品牌管理', icon: '', affix: true }
            },
            {
                path: 'userList',
                component: () => import('@/views/yd/sys/userList'),
                name: 'useList',
                meta: { title: '用户管理', icon: '', affix: true }
            },
            {
                path: 'shoopList',
                component: () => import('@/views/yd/sys/shoopList'),
                name: 'shoopUse',
                meta: { title: '店铺设置', icon: '', affix: true }
            },
            {
                path: 'shopMessage',
                component: () => import('@/views/yd/sys/shopMessage'),
                name: 'shoopUse',
                meta: { title: '店铺信息', icon: '', affix: true }
            },
            {
                path: 'sms',
                component: () => import('@/views/yd/sys/SMSConfig'),
                name: 'SMS',
                meta: { title: '短信配置', icon: '', affix: true }
            },
            {
                path: 'pay',
                component: () => import('@/views/yd/sys/payConfig'),
                name: 'pay',
                meta: { title: '商城支付配置', icon: '', affix: true }
            },
            {
                path: 'categoryList',
                component: () => import('@/views/yd/sys/categoryList'),
                name: 'categoryList',
                meta: { title: '分类维护', icon: '', affix: true }
            },
            {
                path: 'editGoodsPicture',
                component: () => import('@/views/yd/sys/editGoodsPicture'),
                name: 'editGoodsPicture',
                meta: { title: '图片管理', icon: '', affix: true }
            },
            {
                path: 'editGoodsDetail',
                component: () => import('@/views/yd/sys/editGoodsDetail'),
                name: 'editGoodsDetail',
                meta: { title: '图片详情', icon: '', affix: true }
            },
            {
                path: 'supplierList',
                component: () => import('@/views/yd/sys/supplierList'),
                name: 'supplierList',
                meta: { title: '供应商列表', icon: '', affix: true }
            },
            {
                path: 'supplierEdit',
                component: () => import('@/views/yd/sys/supplierEdit'),
                name: 'supplierEdit',
                meta: { title: '供应商编辑', icon: '', affix: true }

            },
            {
                path: 'information',
                component: () => import('@/views/yd/sys/information'),
                name: 'information',
                meta: { title: '站内消息', icon: '', affix: true }
            },
            {
                path: 'informationDetail',
                component: () => import('@/views/yd/sys/informationDetail'),
                name: 'informationDetail',
                meta: { title: '站内消息详情', icon: '', affix: true }

            },
            {
                path: 'wareHouseList',
                component: () => import('@/views/yd/wareHouse/wareHouseList'),
                name: 'wareHouseList',
                meta: { title: '仓库维护', icon: '', affix: true },
            },
            {
                path: 'warehouseDetail',
                component: () => import('@/views/yd/wareHouse/warehouseDetail'),
                name: 'warehouseDetail',
                meta: { title: '仓库详情', icon: '', affix: true },
            },
            {

                path: 'roleList',
                component: () => import('@/views/yd/sys/roleList'),
                name: 'roleList',
                meta: { title: '角色管理', icon: '', affix: true }
            },
            {
                path: 'goodsRecommendList',
                component: () => import('@/views/yd/mall/recommendGoods/recommendRuleList'),
                name: 'recommendGoodsList',
                meta: { title: '商品推荐规则列表', icon: '', affix: true }
            },
            {

                path: 'goodsRecommendDetail',
                component: () => import('@/views/yd/mall/recommendGoods/editRecommendRule'),
                name: 'editRecommendRule',
                meta: { title: '商品推荐规则列表', icon: '', affix: true }
            },
            {

                path: 'dueBank',
                component: () => import('@/views/yd/dueBank/dueBankList'),
                name: 'dueBank',
                meta: { title: '添加银行卡列表', icon: '', affix: true }
            },
            {
                path: 'orderList',
                component: () => import('@/views/yd/sys/orderList'),
                name: 'orderList',
                meta: { title: '订单信息', icon: '', affix: true }
            },
            {
                path: 'birthplace',
                component: () => import('@/views/yd/sys/birthplace'),
                name: 'birthplace',
                meta: { title: '发票信息', icon: '', affix: true }
            },
            {
                path: 'newOrder',
                component: () => import('@/views/yd/sys/newOrder'),
                name: 'newOrder',
                meta: { title: '订单详情', icon: '', affix: true }
            },
            {
                path: 'newCustomer',
                component: () => import('@/views/yd/sys/newCustomer'),
                name: 'newCustomer',
                meta: { title: '新增用户', icon: '', affix: true }
            },
            {
                path: 'newAddress',
                component: () => import('@/views/yd/sys/newAddress'),
                name: 'newAddress',
                meta: { title: '选择地址', icon: '', affix: true }
            },
            {
                path: 'orderData',
                component: () => import('@/views/yd/sys/orderData'),
                name: 'orderData',
                meta: { title: '订单详情', icon: '', affix: true }
            }, {
                path: 'birthplaceClickPage',
                component: () => import('@/views/yd/sys/birthplaceClickPage'),
                name: 'birthplaceClickPage',
                meta: { title: '订单编号', icon: '', affix: true }
            },
            {
                path: 'deliver',
                component: () => import('@/views/yd/sys/deliver'),
                name: 'deliver',
                meta: { title: '发货详情', icon: '', affix: true }
            },
            {
                path: 'afterSale',
                component: () => import('@/views/yd/sys/afterSale'),
                name: 'afterSale',
                meta: { title: '售后管理', icon: '', affix: true }
            },
            {
                path: 'afterSaleDetail',
                component: () => import('@/views/yd/sys/afterSaleDetail'),
                name: 'afterSaleDetail',
                meta: { title: '售后详情', icon: '', affix: true }
            },
            {
                path: 'editSaleAddress',
                component: () => import('@/views/yd/sys/editSaleAddress'),
                name: 'editSaleAddress',
                meta: { title: '修改地址', icon: '', affix: true }
            },
            {
                path: 'agreeAftersale',
                component: () => import('@/views/yd/sys/agreeAftersale'),
                name: 'agreeAftersale',
                meta: { title: '同意退货', icon: '', affix: true }
            },
            {
                path: 'refuseGetback',
                component: () => import('@/views/yd/sys/refuseGetback'),
                name: 'refuseGetback',
                meta: { title: '拒绝退货', icon: '', affix: true }
            },
            {
                path: 'refuseAftersale',
                component: () => import('@/views/yd/sys/refuseAftersale'),
                name: 'refuseAftersale',
                meta: { title: '拒绝退款', icon: '', affix: true }
            },
            {
                path: 'payPage',
                component: () => import('@/views/yd/sys/payPage'),
                name: 'deliver',
                meta: { title: '支付详情', icon: '', affix: true }
            },
            {
                path: 'goUpload',
                component: () => import('@/views/yd/sys/goUpload'),
                name: 'goUpload',
                meta: { title: '上传凭证', icon: '', affix: true }
            },
            // {
            //     path: 'integralCategoryList',
            //     component: () => import('@/views/yd/sys/integralCategoryList'),
            //     name: 'integralCategoryList',
            //     meta: { title: '分类维护', icon: '', affix: true }
            // },
            // {
            //     path: 'integralBrandList',
            //     component: () => import('@/views/yd/sys/integralBrandList'),
            //     name: 'integralBrandList',
            //     meta: { title: '品牌管理', icon: '', affix: true }
            // },
            {
                path: 'WeChatAuthorization',
                component: () => import('@/views/yd/sys/WeChatAuthorization'),
                name: 'WeChatAuthorization',
                meta: { title: '微信授权密钥验证', icon: '', affix: true }
            },
             {
                path: 'getGoodsPrices',
                component: () => import('@/views/yd/sys/goodsPriceList'),
                name: 'getGoodsPrices',
                meta: { title: '商品价格列表', icon: '', affix: true }
            },
            {
                path: 'sampleList',
                component: () => import('@/views/yd/sys/sampleList'),
                name: 'sampleList',
                meta: { title: '样品管理', icon: '', affix: true }
            },
            {
                path: 'repairsList',
                component: () => import('@/views/yd/sys/repairsList'),
                name: 'repairsList',
                meta: { title: '一键报修管理', icon: '', affix: true }
            },
            {
                path: 'repairsDetails',
                component: () => import('@/views/yd/sys/repairsDetails'),
                name: 'repairsDetails',
                meta: { title: '一键报修详情', icon: '',hidden: true,affix: true }
            },
            {
                path: 'null',
                component: () => import('@/views/yd/sys/nullPage'),
                name: 'nullPage',
                meta: { title: '后台', icon: '', affix: true },
            },
            {
                path: 'getGoodsPrices',
                component: () => import('@/views/yd/sys/goodsPriceList'),
                name: 'getGoodsPrices',
                meta: { title: '商品价格列表', icon: '', affix: true }
            },
            {
                path: 'pcSetting',
                component: () => import('@/views/yd/sys/pcSetting'),
                name: 'pcSetting',
                meta: { title: 'PC网站设置', icon: '', affix: true }
            },
            {
                path: 'pcNavbar',
                component: () => import('@/views/yd/sys/pcNavbar'),
                name: 'pcNavbar',
                meta: { title: 'PC导航栏设置', icon: '', affix: true }
            },
        ]
    },
]

export default yd



// WEBPACK FOOTER //
// ./src/router/modules/yd.js